import type { CSSProperties } from 'react';

type ResultValueLabelProps = {
  label: string;
  width: number;
  height: number;
  style?: CSSProperties;
};

/** Live score label — same look as Figma value SVG (Shnobel/Matias + stroke). */
export function ResultValueLabel({
  label,
  width,
  height,
  style,
}: ResultValueLabelProps) {
  return (
    <svg
      className="result-stats-content__value-text result-stats-content__value-text--live"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      style={style}
    >
      <text
        className="result-stats-content__value-text-label"
        textAnchor="middle"
        xmlSpace="preserve"
      >
        <tspan x={width / 2} y={height * 0.72}>
          {label}
        </tspan>
      </text>
    </svg>
  );
}
